<template>
  <span
    class="ChipTime"
    :class="{ 'ChipTime--disabled': disabled }"
  >
    <Time :date="date" />
  </span>
</template>

<script setup lang="ts">
import Time from '../Time/Time.vue';
import type { ChipTimeProps } from './ChipTime.model';

withDefaults(defineProps<ChipTimeProps>(), {
  disabled: false,
});
</script>

<style lang="scss">
@use '@cvo/ui/styles/design-system' as vars;
@use '@cvo/ui/styles/utils/text';

@layer cvo-ui {
  .ChipTime {
    @include text.text(xs);
    display: inline-flex;
    flex-shrink: 0;
    padding-block: vars.$dimensions-d-1;
    padding-inline: vars.$dimensions-d-2;
    border-radius: vars.$dimensions-d-2;
    background-color: vars.$atoms-chips-chip-time-default-bg-color;
    color: vars.$atoms-chips-chip-time-default-text-color;
    white-space: nowrap;

    &--disabled {
      background-color: vars.$atoms-chips-chip-time-disabled-bg-color;
      color: vars.$atoms-chips-chip-time-disabled-text-color;
    }
  }
}
</style>
